import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Wrench, RefreshCw, ArrowRight, LogIn } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const OWNER_EMAIL = "andrea.bazzarello@ptkserv.it";

export default function Maintenance() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [state, setState] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try {
      const { data } = await api.get("/maintenance/status");
      setState(data);
      // Se la maintenance è stata disattivata mentre l'utente era qui → redirect
      if (data && !data.maintenance_mode) {
        navigate("/", { replace: true });
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const isOwner = user && user.email && user.email.trim().toLowerCase() === OWNER_EMAIL;

  const startedAtLabel = state?.started_at
    ? new Date(state.started_at).toLocaleString("it-IT", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" })
    : "—";

  return (
    <div className="min-h-screen ih-bg-ambient flex flex-col items-center justify-center p-6" data-testid="maintenance-page">
      <div className="ih-glass rounded-3xl p-10 max-w-lg w-full text-center border border-lavender-200/60">
        {isOwner && (
          <div className="mb-6 rounded-xl bg-emerald-100 dark:bg-emerald-900/40 text-emerald-800 dark:text-emerald-200 px-4 py-3 text-sm text-left" data-testid="owner-banner">
            <div className="font-semibold mb-1">Manutenzione attiva — hai accesso completo come owner</div>
            <button
              onClick={() => navigate("/")}
              className="inline-flex items-center gap-1.5 text-emerald-700 dark:text-emerald-300 font-medium underline"
              data-testid="owner-goto-dashboard"
            >
              Vai alla Dashboard <ArrowRight className="h-3.5 w-3.5" />
            </button>
          </div>
        )}
        <div className="mx-auto mb-6 h-16 w-16 rounded-full bg-lavender-100 dark:bg-lavender-900/40 flex items-center justify-center">
          <Wrench className="h-8 w-8 text-lavender-700 dark:text-lavender-300 animate-pulse" />
        </div>
        <h1 className="font-display text-3xl sm:text-4xl font-semibold mb-3" data-testid="maintenance-title">Sistema in manutenzione</h1>
        <p className="text-muted-foreground mb-6" data-testid="maintenance-message">
          {loading ? "Caricamento…" : (state?.message || "Torneremo online a breve.")}
        </p>
        {state?.started_at && (
          <div className="text-xs text-muted-foreground mb-8" data-testid="maintenance-started-at">
            Inizio manutenzione: {startedAtLabel}
          </div>
        )}
        <button
          onClick={() => window.location.reload()}
          className="inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-medium bg-lavender-500 hover:bg-lavender-600 text-white shadow-md"
          data-testid="maintenance-retry"
        >
          <RefreshCw className="h-4 w-4" /> Riprova
        </button>

        <div className="mt-5 pt-5 border-t border-border/40 flex justify-center">
          <button
            onClick={() => navigate("/login")}
            className="inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-medium bg-white/70 dark:bg-slate-800/70 hover:bg-white dark:hover:bg-slate-800 border border-lavender-300/60 dark:border-lavender-700/60 text-foreground shadow-sm transition-colors"
            data-testid="maintenance-login-button"
          >
            <LogIn className="h-4 w-4" /> Accedi
          </button>
        </div>
      </div>
      <div className="mt-6 text-xs text-muted-foreground">IH AuditFlow · Invest Hospitality</div>
    </div>
  );
}
